<template>
  <div class="IC-container">
    <div class="IC-left-container">
      <h3>盘点库存序列号：{{ scanNum }}</h3>
      <el-radio-group v-model="TYPE">
        <el-radio :label="1" @change="submitFlag">手机</el-radio>
        <el-radio :label="2" @change="submitFlag">配件</el-radio>
        <!-- <el-radio  :label="3" @change=submitFlag>配件报损</el-radio> -->
      </el-radio-group>
      <div class="scan-barcode-container">
        <el-input type="textarea" :rows="30" v-model="scanBarcode"></el-input>
      </div>
      <el-row style="margin-top: 20px">
        <el-col :span="12" :offset="12">
          <el-button @click="reCheck" type="primary"> 再次盘点 </el-button>
          <el-button @click="submitScanData" type="primary"> 提交 </el-button>
        </el-col>
      </el-row>
    </div>

    <div class="IC-right-container">
      <div>
        <h3>应该在库的手机：{{ InNum }}</h3>
        <div class="scan-barcode-container">
          <el-input
            type="textarea"
            :rows="15"
            v-model="InLibraryArray"
            v-if="this.TYPE == 2 || this.TYPE == 3"
          ></el-input>
          <el-input
            type="textarea"
            :rows="15"
            v-model="phoneInArray"
            v-else
          ></el-input>
        </div>
      </div>
      <div style="margin-top: 15px">
        <div v-if="this.TYPE == 2">
          <h3>缺失的配件：{{ missNum }}</h3>
          <div class="scan-barcode-container">
            <el-input type="textarea" :rows="15" v-model="missData"></el-input>
          </div>
        </div>
        <div v-if="this.TYPE == 1">
          <h3>缺失的手机：{{ missNum }}</h3>
          <div class="scan-barcode-container">
            <el-input type="textarea" :rows="15" v-model="missData"></el-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      userId: 1940693,
      InNum: "",
      missNum: "",
      scanBarcode: "",
      TYPE: 1,
      InLibraryArray: [],
      phoneInArray: [],
      missData: [],
      scanNum:""
    };
  },
  created() {
    this.login();
    
  },
  methods: {
    login() {
      const currentUrl = window.location.toString();
      const urlObject = new URL(currentUrl);
      const searchParams = new URLSearchParams(urlObject.search);
      const userId = searchParams.get("qfExtUserId");
      if (userId != null || userId != undefined) {
        this.userId = userId;
      }
      console.log("userid:", this.userId);
      // 创建一个新的 Axios 实例专用于 /orderListApi 请求
      const loginApiInstance = axios.create({
        baseURL: "/loginApi",
      });
      //使用FormData对象发送POST请求
      loginApiInstance
        .get("monkeyshop/user/login/" + this.userId)
        .then((res) => {
          // this.tableData = res.data.data;
          if (res.data.code == 200) {
            this.submitFlag();
          } else {
            alert(res.data.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    reCheck() {
      this.InNum = "";
      this.missNum = "";
      this.scanBarcode = "";
      this.TYPE = "";
      this.InLibraryArray = [];
      this.phoneInArray = [];
      this.missData = [];
    },
    submitScanData() {
      console.log(typeof(this.scanBarcode), "-------scanBarcode1---------");
      console.log(Object.prototype.toString.call(this.scanBarcode), "-------scanBarcode---------");

      const barCodeSplist = this.scanBarcode.split("\n");
      const BarcodeList = Array.from(new Set(barCodeSplist));
      const oneBarcode = BarcodeList.filter(item => item.trim() !== "");
      this.scanNum = oneBarcode.length

      console.log(this.scanNum, "----------scanNum---------");
      console.log(oneBarcode, "----------oneBarcode---------");
      // 创建一个新的 Axios 实例专用于 /OCRApi 请求
      const ocrApiInstance = axios.create({
        baseURL: "/OCRApi",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (this.TYPE == 1) {
        let PhoneArr = JSON.parse(JSON.stringify(this.phoneInArray));
        console.log(PhoneArr, "----------PhoneArr---------");
        this.missData = PhoneArr.filter((item) => !oneBarcode.includes(item));
        this.missNum = this.missData.length;
        let inventoryCheckData = {};
        inventoryCheckData.type = "手机";
        inventoryCheckData.hasNos = oneBarcode;
        inventoryCheckData.nonNos = this.missData;
        console.log(inventoryCheckData, "inventoryCheckData");
        ocrApiInstance
          .post(
            "monkeyshop/common/saveInventoryCheckByQingLiu",
            inventoryCheckData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            this.$message({
              message: "入库信息提交成功",
              type: "success",
            });
            console.log(res, "res");
          })
          .catch(function (error) {
            this.$message.error("入库信息提交失败，请重新操作");
            console.log(error);
          });
      } else {
        let PJArr = JSON.parse(JSON.stringify(this.InLibraryArray));
        console.log(PJArr, "----------PJArr---------");
        this.missData = PJArr.filter((item) => !oneBarcode.includes(item));
        this.missNum = this.missData.length;
        let inventoryCheckData = {};
        inventoryCheckData.type = "配件";
        inventoryCheckData.hasNos = oneBarcode;
        inventoryCheckData.nonNos = this.missData;
        console.log(inventoryCheckData, "inventoryCheckData");
        ocrApiInstance
          .post(
            "monkeyshop/common/saveInventoryCheckByQingLiu",
            inventoryCheckData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            this.$message({
              message: "入库信息提交成功",
              type: "success",
            });
            console.log(res, "res");
          })
          .catch(function (error) {
            this.$message.error("入库信息提交失败，请重新操作");
            console.log(error);
          });
      }
    },
    submitFlag() {
      console.log(this.TYPE, "TYPE");
      this.scanBarcode = "";
      this.missData = [];
      if (this.TYPE == 1) {
        this.allPhoneInInfo();
      } else if (this.TYPE == 2 || this.TYPE == 3) {
        this.missNum = "";
        this.allInventoryPJInfo();
      }
    },
    allInventoryPJInfo() {
      var that = this;
      that.InLibraryArray = [];
      const apiInstance = axios.create({
        baseURL: "/outBoundApi",
        "Content-Type": "application/json",
      });
      
      //使用FormData对象发送POST请求
      console.log(params, "params");
      apiInstance
        .post("monkeyshop/common/queryInStockMobilePhones/"+this.userId)
        .then((res) => {
          console.log(res, "res");
          that.InLibraryArray = res.data.data;
          that.InNum = that.InLibraryArray.length;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    removeEmptyStrings(array) {
      return array.filter(item => item !== undefined && item !== '');
    },
    allPhoneInInfo() {
      var that = this;
      that.phoneInArray = [];
      axios({
        method: "post",
        url: "openApi/app/5u91so0c1801/apply/filter",
        data: {
          pageSize: 200,
          pageNum: 1,
          queries: [
              {
                queId: 182383150,
                searchKey: "在库",
              },
            ],
        },
        headers: {
          "Content-Type": "application/json",
          accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
        },
        withCredentials: true,
      })
        .then((res) => {
          console.log(res);
          let resData = res.data.result.result;
          for (var i = 0; i < resData.length; i++) {
            // 首先检查是否存在queId等于182383150且dataValue等于"在库"的项目
            const isInStorage = resData[i].answers.some(
              (answer) =>
                answer.queId === 182383150 &&
                answer.values.some((value) => value.dataValue === "在库")
            );
            // console.log(value)
            // 如果存在，再提取所有SN码
            // let values = [];
            // if (isInStorage) {
            //   values = resData[i].answers
            //     .filter((answer) => answer.queId === 182383141)
            //     .flatMap((answer) =>
            //       answer.values.map((value) => value.dataValue)
            //     );
            // }
            // 如果存在，再提取所有IMEI码
            let values = [];
            if (isInStorage) {
              values = resData[i].answers
                .filter((answer) => answer.queId === 182383142)
                .flatMap((answer) =>
                  answer.values.map((value) => value.dataValue)
                );
            }
            console.log(values); // 输出符合条件的dataValue的值
            that.phoneInArray.push(values[0]);
            console.log(that.phoneInArray, "that.phoneInArray");
          }
          console.log(that.phoneInArray, "phoneInArray");
          let newPhoneInArray = Array.from(new Set(that.phoneInArray));
          that.phoneInArray = newPhoneInArray.filter(item => item !== undefined);
          console.log(that.phoneInArray,'that.phoneInArray')
          that.InNum = that.phoneInArray.length;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.IC-container {
  display: flex;
  width: 100%;
  height: 900px;
}
.IC-left-container {
  /* background-color: #d9ecff; */
  width: 48%;
  margin: 25px;
  padding: 2%;
  border: 2px solid #c0c4cc;
  border-radius: 20px;
}
.IC-right-container {
  /* background-color:  #d9ecff; */
  width: 48%;
  margin: 25px;
  padding: 2%;
  border-radius: 20px;
  border: 2px solid #c0c4cc;
}
.scan-barcode-container {
  margin-top: 15px;
  width: 95%;
}
h3 {
  text-align: left;
}
.el-button--primary {
  color: #fff;
  background-color: #fb9337;
  border-color: #fb9337;
}
</style>


// WEBPACK FOOTER //
// src/views/inventoryCheck.vue